import { render, staticRenderFns } from "./FrameSealPsn.vue?vue&type=template&id=52860dcb&scoped=true"
import script from "./FrameSealPsn.vue?vue&type=script&lang=js"
export * from "./FrameSealPsn.vue?vue&type=script&lang=js"
import style0 from "./FrameSealPsn.vue?vue&type=style&index=0&id=52860dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52860dcb",
  null
  
)

export default component.exports